import { action, payload } from 'ts-action'
import { ICalendarEvent } from '@network/models/calendar-event.model'
import { IError } from '@network/models/global.model'

export const BusinessCalendarEventsFetching = action(
  'BusinessCalendarEventsFetching',
  payload<boolean>(),
)

export const GetBusinessCalendarEvents = action(
  'GetBusinessCalendarEvents',
  payload<ICalendarEvent[]>(),
)

export const GetBusinessCalendarEventsErrors = action(
  'GetBusinessCalendarEventsErrors',
  payload<IError>(),
)
